import type { RobinConversation } from "../robin-types"

/** Robin's presence states — one mark, eight cold-readable frames. */
export type RobinState =
  | "idle"
  | "listening"
  | "thinking"
  | "responding"
  | "waiting"
  | "speaking"
  | "error"
  | "done"

/**
 * Maps a conversation's live status to Robin's presence state, so one avatar
 * (e.g. in the chat header) reflects exactly what's happening right now.
 */
export function robinStateFor(conv: RobinConversation): RobinState {
  if (conv.pending) return "thinking"
  const last = conv.messages[conv.messages.length - 1]
  if (last?.role === "assistant" && last.streamChars != null) return "responding"
  if (conv.status === "needs_you") return "waiting"
  if (conv.status === "failed") return "error"
  return "idle"
}
